import React, { useEffect, useState } from 'react'
import "./TopBar.scss";
import { DescriptionContent, IconContent, RedMainHeading } from '../../Global/GlobalText';
import { SelectBorder } from '../../Global/GlobalFormElement';
import {  GreylessradiusButton } from '../../Global/GlobalButton';
import { useSelector } from 'react-redux';
import { EXCHNAGE_URL } from '../../../Url/Url';
import axios from 'axios';
import { toast } from 'react-toastify';


export const TopBar = () => {
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const initialEventId = String(eventIdGet);
  const [selectedStatus, setSelectedStatus] = useState(''); 
  const [statusFlags, setStatusFlags] = useState({
    is_live: 0,
    is_draft: 0,
    is_archive: 0,
  });


 

  const token = localStorage.getItem("token")
  const handleStatusChange = async (e) => {
    const selectedValue = e.target.value;

    let updatedFlags = {
      is_live: 0,
      is_draft: 0,
      is_archive: 0,
    };

    if (selectedValue === 'Live') {
      updatedFlags.is_live = 1;
    } else if (selectedValue === 'Draft') {
      updatedFlags.is_draft = 1;
    } else if (selectedValue === 'Archive') {
      updatedFlags.is_archive = 1;
    }

    setSelectedStatus(selectedValue);
    setStatusFlags(updatedFlags);

    try {
      const response = await axios.post(`${EXCHNAGE_URL}/eventStatus`, 
       { eventId: initialEventId, 
        ...updatedFlags,  
       },
       { 
        headers: {
          Authorization: `Bearer ${token}`,  
        },
      },
      );

      if (response.data.status === true) {
        toast.success("Status Of The Event Changed Successfully.");
        localStorage.setItem(`eventStatus_${initialEventId}`, selectedValue);

      } else {
        toast.error('Failed to update event status:', response.data.message);
      }
    } catch (error) {
      console.error('Error updating event status with axios:', error);
    }
  };

  useEffect(() => {
    const getApi2 = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${EXCHNAGE_URL}/getEvent/${initialEventId}`, {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const events = response.data.data;
          console.log("Fetched Events:", events);
          setData(events);
          const event = events.find((ev) => String(ev.id) === initialEventId);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    getApi2();
  }, [initialEventId, token]); 


  useEffect(() => {
    const getApi = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${EXCHNAGE_URL}/dashboardEvents`, {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const events = response.data.data;
          console.log("Fetched Events:", events);
          const event = events.find((ev) => String(ev.id) === initialEventId);

          if (event) {
            let status = ""; 

            if (event.is_live) status = "Live";
            else if (event.is_archive) status = "Archive";
            else if (event.is_draft) status = "Draft";

            setSelectedStatus(status);
            updateStatusFlags(status);

            localStorage.setItem(`eventStatus_${initialEventId}`, status);
          } else {
            const storedStatus = localStorage.getItem(
              `eventStatus_${initialEventId}`
            );
            if (storedStatus) {
              setSelectedStatus(storedStatus);
              updateStatusFlags(storedStatus);
            } else {
              setSelectedStatus("");
              updateStatusFlags("");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    getApi();
  }, [initialEventId, token]); 

  const updateStatusFlags = (status) => {
    let updatedFlags = {
      is_live: 0,
      is_draft: 0,
      is_archive: 0,
    };

    if (status === 'Live') {
      updatedFlags.is_live = 1;
    } else if (status === 'Draft') {
      updatedFlags.is_draft = 1;
    } else if (status === 'Archive') {
      updatedFlags.is_archive = 1;
    }

    setStatusFlags(updatedFlags);
  };


console.log(data,"adssdsds")
  const handleClick = () => {
    window.open(data.event_url, "_blank"); 
  };

  return (
    <div>
        <div className='topbar_div'>
            <div className='topbar_heading_div'>
                <RedMainHeading>{data.event_name}</RedMainHeading>
            </div>

            <div className='topbar_draft_div'>

                <div className='topbar_entry_div'>
                    <DescriptionContent>Entrants</DescriptionContent>
                    <IconContent>{data.totalEntrants}</IconContent>

                </div>

                <div className='topbar_entry_div'>
                    <DescriptionContent>Total Completed submissions</DescriptionContent>
                    <IconContent className='topbar_outof'>{data.totalSubmissions} of {data.totalSubmissions}</IconContent>
                </div>

                <SelectBorder style={{width: "110px"}} value={selectedStatus} onChange={handleStatusChange}>
                  <option value="Draft">Draft</option>
                  <option value="Archive">Archive</option>
                  <option value="Live">Live</option>
                </SelectBorder>

                <GreylessradiusButton onClick={handleClick}  >My Event</GreylessradiusButton>


            </div>
        </div>
    </div>
  )
}
